// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1be4V","calendarButtons":"ClockData_calendarButtons__1WYIp"};